<template>
  <div>
    <div class="mb-4">
      <v-btn color="grey" variant="outlined"to="/setting/staff"> 一覧へ </v-btn>
    </div>

    <v-row v-if="staffDetail" no-gutters>
      <page-title
        :value="staffDetail.lastName + staffDetail.firstName"
      ></page-title>
      <v-spacer />
      <v-btn @click="editStaff" color="primary" variant="flat"> スタッフ編集 </v-btn>
    </v-row>

    <v-row v-else>
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </v-row>

    <v-container class="pt-12" v-if="staffDetail">
      <v-row>
        <v-col cols="4"> スタッフ区分 </v-col>
        <v-col cols="8">
          {{ staffDetail.category == "general" ? "一般" : "ヘルプ" }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 氏名 </v-col>
        <v-col cols="8">
          {{ staffDetail.lastName + staffDetail.firstName }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 氏名（カナ） </v-col>
        <v-col cols="8">
          {{ staffDetail.lastNameKana + staffDetail.firstNameKana }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 役職 </v-col>
        <v-col cols="8">
          {{
            (!!staffDetail.isChief ? "主任" : "") +
            " " +
            (!!staffDetail.isDirector ? "施設長" : "") +
            " " +
            (!!staffDetail.isAdmin ? "管理者" : "")
          }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> スタッフコード1 </v-col>
        <v-col cols="8">
          {{ staffDetail.staffCode1 }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> スタッフコード2 </v-col>
        <v-col cols="8">
          {{ staffDetail.staffCode2 }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 生年月日 </v-col>
        <v-col cols="8">
          {{ staffDetail.birth }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 性別 </v-col>
        <v-col cols="8">
          {{ staffDetail.gender == "male" ? "男性" : "女性" }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 電話番号1 </v-col>
        <v-col cols="8">
          {{ staffDetail.phoneNumber1 }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 電話番号2 </v-col>
        <v-col cols="8">
          {{ staffDetail.phoneNumber2 }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 入社日 </v-col>
        <v-col cols="8">
          {{ staffDetail.joinDate }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 配属日 </v-col>
        <v-col cols="8">
          {{ staffDetail.assignDate }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 退社日 </v-col>
        <v-col cols="8">
          {{ staffDetail.retireDate }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 退社理由 </v-col>
        <v-col cols="8">
          {{ getRetireReasonText(staffDetail.retireReason || "") }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 退社理由詳細 </v-col>
        <v-col cols="8">
          {{ staffDetail.retireReasonComment }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="4"> 備考 </v-col>
        <v-col cols="8">
          {{ staffDetail.comment }}
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/atoms/PageTitle.vue";
import LocalDataService from "@/service/LocalDataService";
import { staffModule } from "@/store/dataModules/staffModule";
import { staffEditModule } from "@/store/dataModules/staffEditModule";
import Swal from "sweetalert2";

export default defineComponent({
  name: "StaffDetail",

  components: {
    PageTitle,
  },

  mounted() {
    this.getStaff();
  },

  data() {
    return {
      retireSelectValues: [
        { text: "", value: "" },
        { text: "異動", value: "transfer" },
        { text: "退職", value: "retire" },
        { text: "死亡", value: "die" },
      ],
    };
  },

  computed: {
    userNurseryId: function () {
      return this.$route.params.id;
    },
    staffDetail: function () {
      return staffModule.staffDetail;
    },
  },

  methods: {
    async getStaff() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        await staffModule.getStaff({
          nurseryId: String(nurseryId),
          userNurseryId: this.userNurseryId as string,
        });
      }
    },
    async deleteStaff() {
      Swal.fire({
        title: "警告",
        text: "スタッフを削除しますか？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "red",
        cancelButtonColor: "grey",
        confirmButtonText: "削除",
        cancelButtonText: "キャンセル",
      }).then((result) => {
        if (result.isConfirmed) {
          const nurseryId = LocalDataService.getNurseryId();
          if (nurseryId) {
            staffEditModule
              .deleteStaff({
                nurseryId: String(nurseryId),
                userNurseryId: this.userNurseryId as string,
              })
              .then((response) => {
                if (response) {
                  Swal.fire({ title: "削除しました", icon: "success" });
                  this.$router.push({ path: "/setting/staff" });
                } else {
                  Swal.fire({ title: "失敗しました", icon: "error" });
                }
              });
          }
        }
      });
    },
    editStaff() {
      this.$router.push({ path: `/setting/staff/${this.userNurseryId}/edit` });
    },
    getRetireReasonText(value: string): string {
      return this.retireSelectValues.find((r) => r.value == value)?.text || "";
    },
  },
});
</script>
